export const DRAWING_ACTIONS = {
  draw: 'draw',
  clean: 'clean',
  highlighter: 'highlighter',
  undo: 'undo',
};

export const DRAWING_COLORS = {
  red: 'red',
  green: 'green',
  black: 'black',
  white: 'white',
  yellow: 'yellow',
  blue: 'blue',
};

export const DRAWING_WIDTHS = { Thin: 3, Normal: 5, Thick: 8 };
